const ASSET_MAX_DECIMALS = {
  BTC: 6,
  ETH: 4,
  TON: 2,
  SOL: 3,
  TRX: 2,
  USDT: 2,
  USDC: 2,
};

const safeNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

const roundDownToDecimals = (value, decimals) => {
  const val = safeNumber(value);
  const digits = Number.isInteger(decimals) ? Math.max(0, decimals) : 0;
  if (digits === 0) return val >= 0 ? Math.floor(val) : Math.ceil(val);
  const factor = 10 ** digits;
  if (!Number.isFinite(factor) || factor <= 0) return val;
  if (val >= 0) return Math.floor((val + Number.EPSILON) * factor) / factor;
  return Math.ceil((val - Number.EPSILON) * factor) / factor;
};

const trimTrailingZeros = (value, minDecimals) => {
  if (!value.includes(".")) return value;
  const [intPart, decPart] = value.split(".");
  if (!decPart) return intPart;
  const trimmed = decPart.replace(/0+$/, "");
  if (trimmed.length >= minDecimals) {
    return trimmed.length > 0 ? `${intPart}.${trimmed}` : intPart;
  }
  const padded = decPart.slice(0, minDecimals).padEnd(minDecimals, "0");
  return `${intPart}.${padded}`;
};

export const getAssetMaxDecimals = (currency) => {
  const key = String(currency || "").toUpperCase();
  return ASSET_MAX_DECIMALS[key] ?? 6;
};

export const formatAssetAmount = (
  amount,
  currency,
  { hideBalance = false, minDecimals = 2, maxDecimals } = {}
) => {
  if (hideBalance) return "••••";
  const value = safeNumber(amount);
  const resolvedMax = Number.isInteger(maxDecimals)
    ? maxDecimals
    : getAssetMaxDecimals(currency);
  const normalized = roundDownToDecimals(value, resolvedMax);
  const formatted = normalized.toLocaleString("en-US", {
    minimumFractionDigits: minDecimals,
    maximumFractionDigits: resolvedMax,
  });
  if (resolvedMax <= minDecimals) return formatted;
  return trimTrailingZeros(formatted, minDecimals);
};

export const toAssetInputString = (amount, currency) => {
  const value = safeNumber(amount);
  const decimals = getAssetMaxDecimals(currency);
  const normalized = roundDownToDecimals(value, decimals);
  return normalized.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
    useGrouping: false,
  }).replace(/\.?0+$/, "");
};
